
'use strict'

import NewsDraggableList from "../../utils/NewsDraggableList";
import Subscribe from "../../utils/Subscribe";
import NewsDetailShare from "./NewsDetailShare";

class NewsDetail{
    constructor(){
        this.main = document.getElementById('news_detail');
        
        this._share = new NewsDetailShare();
        this._subscribe = new Subscribe(this.main.querySelector('.subscribe'));
        this._others = new NewsDraggableList(document.getElementById('news_detail_others'));
    }
}

export default NewsDetail;